'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var BaseApi = require('./utils/baseApi');
var RequestProvider = require('ky')["default"];
var Acl = require('./services/acl');
var Appointment = require('./services/appointment');
var Apporteur = require('./services/apporteur');
var Audit = require('./services/audit');
var Authentication = require('./services/authentication');
var Blacklist = require('./services/blacklist');
var Bookmark = require('./services/bookmark');
var Calendar = require('./services/calendar');
var Client = require('./services/client');
var Commercialisation = require('./services/commercialisation');
var Commission = require('./services/commission');
var Company = require('./services/company');
var Document = require('./services/document');
var Docusign = require('./services/docusign');
var Feed = require('./services/feed');
var Geo = require('./services/geo');
var Image = require('./services/image');
var Lead = require('./services/lead');
var Mail = require('./services/mail');
var Mailchimp = require('./services/mailchimp');
var Mandate = require('./services/mandate');
var Marketplace = require('./services/marketplace');
var Notification = require('./services/notification');
var Partner = require('./services/partner');
var Pdf = require('./services/pdf');
var Phone = require('./services/phone');
var PrestigePropertyGroup = require('./services/prestige-property-group');
var Property = require('./services/property');
var PublisherApits = require('./services/publisher-apits');
var PublisherBellesPierres = require('./services/publisher-belles-pierres');
var PublisherDatabase = require('./services/publisher-database');
var PublisherElasticsearch = require('./services/publisher-elasticsearch');
var PublisherFrancePropertyShop = require('./services/publisher-france-property-shop');
var PublisherFrenchProperty = require('./services/publisher-french-property');
var PublisherGreenAcres = require('./services/publisher-green-acres');
var PublisherHamptons = require('./services/publisher-hamptons');
var PublisherLuxResidence = require('./services/publisher-lux-residence');
var PublisherOldElasticsearch = require('./services/publisher-old-elasticsearch');
var PublisherParuvendu = require('./services/publisher-paruvendu');
var PublisherPrestige = require('./services/publisher-prestige');
var PublisherRightmove = require('./services/publisher-rightmove');
var PublisherSeloger = require('./services/publisher-seloger');
var PublisherSki = require('./services/publisher-ski');
var PublisherUbiflow = require('./services/publisher-ubiflow');
var PublisherZoopla = require('./services/publisher-zoopla');
var Rhinov = require('./services/rhinov');
var Taktik = require('./services/taktik');
var Template = require('./services/template');
var Tenant = require('./services/tenant');
var Thread = require('./services/thread');
var Timemachine = require('./services/timemachine');
var User = require('./services/user');
var Wallet = require('./services/wallet');
module.exports = /*#__PURE__*/function (_BaseApi) {
  _inherits(HestiaApi, _BaseApi);
  var _super = _createSuper(HestiaApi);
  function HestiaApi(options) {
    var _this;
    _classCallCheck(this, HestiaApi);
    _this = _super.call(this, options, RequestProvider);
    _this.Acl = new Acl(_this.http);
    _this.Appointment = new Appointment(_this.http);
    _this.Apporteur = new Apporteur(_this.http);
    _this.Audit = new Audit(_this.http);
    _this.Authentication = new Authentication(_this.http);
    _this.Blacklist = new Blacklist(_this.http);
    _this.Bookmark = new Bookmark(_this.http);
    _this.Calendar = new Calendar(_this.http);
    _this.Client = new Client(_this.http);
    _this.Commercialisation = new Commercialisation(_this.http);
    _this.Commission = new Commission(_this.http);
    _this.Company = new Company(_this.http);
    _this.Document = new Document(_this.http);
    _this.Docusign = new Docusign(_this.http);
    _this.Feed = new Feed(_this.http);
    _this.Geo = new Geo(_this.http);
    _this.Image = new Image(_this.http);
    _this.Lead = new Lead(_this.http);
    _this.Mail = new Mail(_this.http);
    _this.Mailchimp = new Mailchimp(_this.http);
    _this.Mandate = new Mandate(_this.http);
    _this.Marketplace = new Marketplace(_this.http);
    _this.Notification = new Notification(_this.http);
    _this.Partner = new Partner(_this.http);
    _this.Pdf = new Pdf(_this.http);
    _this.Phone = new Phone(_this.http);
    _this.PrestigePropertyGroup = new PrestigePropertyGroup(_this.http);
    _this.Property = new Property(_this.http);
    _this.PublisherApits = new PublisherApits(_this.http);
    _this.PublisherBellesPierres = new PublisherBellesPierres(_this.http);
    _this.PublisherDatabase = new PublisherDatabase(_this.http);
    _this.PublisherElasticsearch = new PublisherElasticsearch(_this.http);
    _this.PublisherFrancePropertyShop = new PublisherFrancePropertyShop(_this.http);
    _this.PublisherFrenchProperty = new PublisherFrenchProperty(_this.http);
    _this.PublisherGreenAcres = new PublisherGreenAcres(_this.http);
    _this.PublisherHamptons = new PublisherHamptons(_this.http);
    _this.PublisherLuxResidence = new PublisherLuxResidence(_this.http);
    _this.PublisherOldElasticsearch = new PublisherOldElasticsearch(_this.http);
    _this.PublisherParuvendu = new PublisherParuvendu(_this.http);
    _this.PublisherPrestige = new PublisherPrestige(_this.http);
    _this.PublisherRightmove = new PublisherRightmove(_this.http);
    _this.PublisherSeloger = new PublisherSeloger(_this.http);
    _this.PublisherSki = new PublisherSki(_this.http);
    _this.PublisherUbiflow = new PublisherUbiflow(_this.http);
    _this.PublisherZoopla = new PublisherZoopla(_this.http);
    _this.Rhinov = new Rhinov(_this.http);
    _this.Taktik = new Taktik(_this.http);
    _this.Template = new Template(_this.http);
    _this.Tenant = new Tenant(_this.http);
    _this.Thread = new Thread(_this.http);
    _this.Timemachine = new Timemachine(_this.http);
    _this.User = new User(_this.http);
    _this.Wallet = new Wallet(_this.http);
    return _this;
  }
  _createClass(HestiaApi, [{
    key: "http",
    get: function get() {
      return this._http;
    },
    set: function set(http) {
      this._http = http;
      this.Acl.setHttp(http);
      this.Appointment.setHttp(http);
      this.Apporteur.setHttp(http);
      this.Audit.setHttp(http);
      this.Authentication.setHttp(http);
      this.Blacklist.setHttp(http);
      this.Bookmark.setHttp(http);
      this.Calendar.setHttp(http);
      this.Client.setHttp(http);
      this.Commercialisation.setHttp(http);
      this.Commission.setHttp(http);
      this.Company.setHttp(http);
      this.Document.setHttp(http);
      this.Docusign.setHttp(http);
      this.Feed.setHttp(http);
      this.Geo.setHttp(http);
      this.Image.setHttp(http);
      this.Lead.setHttp(http);
      this.Mail.setHttp(http);
      this.Mailchimp.setHttp(http);
      this.Mandate.setHttp(http);
      this.Marketplace.setHttp(http);
      this.Notification.setHttp(http);
      this.Partner.setHttp(http);
      this.Pdf.setHttp(http);
      this.Phone.setHttp(http);
      this.PrestigePropertyGroup.setHttp(http);
      this.Property.setHttp(http);
      this.PublisherApits.setHttp(http);
      this.PublisherBellesPierres.setHttp(http);
      this.PublisherDatabase.setHttp(http);
      this.PublisherElasticsearch.setHttp(http);
      this.PublisherFrancePropertyShop.setHttp(http);
      this.PublisherFrenchProperty.setHttp(http);
      this.PublisherGreenAcres.setHttp(http);
      this.PublisherHamptons.setHttp(http);
      this.PublisherLuxResidence.setHttp(http);
      this.PublisherOldElasticsearch.setHttp(http);
      this.PublisherParuvendu.setHttp(http);
      this.PublisherPrestige.setHttp(http);
      this.PublisherRightmove.setHttp(http);
      this.PublisherSeloger.setHttp(http);
      this.PublisherSki.setHttp(http);
      this.PublisherUbiflow.setHttp(http);
      this.PublisherZoopla.setHttp(http);
      this.Rhinov.setHttp(http);
      this.Taktik.setHttp(http);
      this.Template.setHttp(http);
      this.Tenant.setHttp(http);
      this.Thread.setHttp(http);
      this.Timemachine.setHttp(http);
      this.User.setHttp(http);
      this.Wallet.setHttp(http);
    }
  }], [{
    key: "services",
    get: function get() {
      return ['Acl', 'Appointment', 'Apporteur', 'Audit', 'Authentication', 'Blacklist', 'Bookmark', 'Calendar', 'Client', 'Commercialisation', 'Commission', 'Company', 'Document', 'Docusign', 'Feed', 'Geo', 'Image', 'Lead', 'Mail', 'Mailchimp', 'Mandate', 'Marketplace', 'Notification', 'Partner', 'Pdf', 'Phone', 'PrestigePropertyGroup', 'Property', 'PublisherApits', 'PublisherBellesPierres', 'PublisherDatabase', 'PublisherElasticsearch', 'PublisherFrancePropertyShop', 'PublisherFrenchProperty', 'PublisherGreenAcres', 'PublisherHamptons', 'PublisherLuxResidence', 'PublisherOldElasticsearch', 'PublisherParuvendu', 'PublisherPrestige', 'PublisherRightmove', 'PublisherSeloger', 'PublisherSki', 'PublisherUbiflow', 'PublisherZoopla', 'Rhinov', 'Taktik', 'Template', 'Tenant', 'Thread', 'Timemachine', 'User', 'Wallet'];
    }
  }]);
  return HestiaApi;
}(BaseApi);